import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, Check } from 'lucide-react';

const ServiceCard = ({ service }) => {
  return (
    <div className="bg-slate-900 rounded-xl shadow-lg overflow-hidden border border-slate-700 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#fd5a27]/20 hover:border-[#fd5a27]">
      <div className="h-48 overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover transition-transform hover:scale-110"
        />
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
        <p className="text-gray-300 text-sm mb-4">{service.description}</p>
        
        <ul className="space-y-2 mb-6">
          {service.features.map((feature, index) => (
            <li key={index} className="flex items-center text-sm text-gray-200">
              <Check className="w-4 h-4 text-[#fd5a27] mr-2" />
              {feature}
            </li>
          ))}
        </ul>
        
        <div className="flex gap-2">
          <Link to={`/services/${service.id}`} className="flex-1">
            <Button variant="outline" className="w-full border-[#fd5a27] text-[#fd5a27] hover:bg-[#fd5a27] hover:text-white hover:border-[#fd5a27] transition-all duration-300">
              Learn More
            </Button>
          </Link>
          <Button className="bg-[#fd5a27] hover:bg-amber-500 text-white transition-all duration-300">
            <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
